import keycloakRoles, {
    type KeycloakRoleSnapshot,
} from '../../services/auth/keycloak-roles.service';
import { localDevAuthBypass } from '../../services/auth/localDevAuthBypass';
import { AI_OBSERVABILITY_CLIENT_ROLES } from '../aiObservability/aiObservabilityAccess';

export const CHAT_DASHBOARD_ACCESS = 'CHAT_DASHBOARD' as const;

export type ChatDashboardAccessState = 'checking' | 'allowed' | 'denied';

// Mirrors the server's HTTP policy for the endpoints this page actually
// calls: CanViewSessions() on SessionsController (recruitment-app client
// role recruitment-view-sessions or recruitment-manage-sessions, no realm
// role) — deliberately not the admin-realm-gated AI observability policy
// that shares the same client-role list. The chat socket gateway's
// SocketAuthService.canViewSessions additionally admits realm `admin` as a
// third way in, but a caller who only has that realm role and neither
// session client role can't load this page's data over HTTP anyway, so
// there is nothing useful to mirror on the frontend for that case.
export const canAccessChatDashboard = (snapshot: KeycloakRoleSnapshot): boolean =>
    AI_OBSERVABILITY_CLIENT_ROLES.some((role) => snapshot.clientRoles.includes(role));

export const resolveChatDashboardAccess = async (): Promise<boolean> =>
    localDevAuthBypass() || canAccessChatDashboard(await keycloakRoles.getRoleSnapshot('recruitment-app'));
